import React, {Fragment, useContext, useEffect, useState} from 'react';

import {Col, Form, FormGroup, Input, Label, Table} from 'reactstrap';

import {useForm} from "react-hook-form";
import {Btn, H6} from "../../../../../AbstractElements";
import Loader from "../../../../../Layout/Loader";
import axiosConfig from "../../../../../Config/axios";
import BackendDropDown from "../../../../../CommonElements/DropDown/BackendDropDown";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import SvgIcon from "../../../../../Components/Common/Component/SvgIcon";
import WalletFixAmountForm from "../../../Wallet/WalletTransaction/Component/WalletFixAmountForm";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {
    BoardNumberParticipantFormValues,
    BoardNumberParticipantFormProps,
    BookingType
} from "../../Types/BoardTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import {WalletType} from "../../../Wallet/Types/WalletTypes";

const BoardNumberParticipantForm: React.FC<BoardNumberParticipantFormProps> = ({
                                                                                   callBack,
                                                                                   boardID,
                                                                                   boardNumberID,
                                                                               }) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [bordBookingTypes, setBordBookingTypes] = useState<BookingType[]>([]);
    const [pricingList, setPricingList] = useState<number[]>([]);
    const [pricingListVisibility, setPricingListVisibility] = useState<boolean>(false);
    const [selectedParticipantID, setSelectedParticipantID] = useState<number | undefined>();
    const [selectedParticipantWallet, setSelectedParticipantWallet] = useState<WalletType>();
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register, handleSubmit, setError, clearErrors, formState: {errors}, getValues
    } = useForm<BoardNumberParticipantFormValues>();
    const {ref, ...rest} = register('board_booking_type_id');
    useEffect(() => {
        const pricing: number[] = []
        for (let i = 50; i <= 1000; i += 50) {
            pricing.push(i);
        }
        setPricingList(pricing);
    }, [selectedParticipantWallet])

    useEffect(() => {
        selectedParticipantID && getWallet(selectedParticipantID);
    }, [selectedParticipantID])

    const onSubmit = (data: BoardNumberParticipantFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        createBoardParticipant(data);
    }

    const createBoardParticipant = (data: BoardNumberParticipantFormValues) => {
        const bookingTypeId = parseInt(data.board_booking_type_id.toString());
        const dataToSubmit: BoardNumberParticipantFormValues = {
            ...data,
            board_booking_type_id: bookingTypeId,
            board_number_id: boardNumberID,
            wallet_id: selectedParticipantWallet?.id,
            participant_id: selectedParticipantID || 0,
            value: bordBookingTypes.find(bt => bt.id === bookingTypeId)?.amount || 0
        };
        setLoaderVisibility(true);
        axiosConfig
            .post(getApplicationRoute('board-number-participant'), dataToSubmit)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data) {
                    callBack?.();
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    const getWallet = (participantID: number) => {
        setLoaderVisibility(true);
        const config = {
            params: {
                participant_id: participantID,
                wallet_type: 'wallet-type-points'
            }
        };
        axiosConfig
            .get(getApplicationRoute('wallet'), config)
            .then((response: { data: { data: any[]; }; }) => {
                if (response?.data?.data?.data?.length) {
                    setSelectedParticipantWallet(response?.data.data.data[0]);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    useEffect(() => {
        getBoardBookingType();
    }, []);

    const getBoardBookingType = () => {
        setLoaderVisibility(true);
        const config = {
            params: {
                board_id: boardID
            }
        };
        axiosConfig
            .get(getApplicationRoute('board-booking-type'), config)
            .then((response: { data: { data: BookingType[]; }; }) => {
                if (response?.data?.data) {
                    setBordBookingTypes(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    return (<Fragment>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Loader visibility={loaderVisibility}/>
            <BackendDropDown name={'participant_id'} onChange={(value: any) => setSelectedParticipantID(value?.value)}
                             type={'select-url'}
                             label={'Participant'}
                             getValues={getValues}
                             register={register}
                             params={{collector_board_id: boardID}}
                             errors={errors} url={'application/participant'} options={{required: true}}/>
            {selectedParticipantID && selectedParticipantWallet ? <Table>
                <tbody>
                <tr>
                    <td>
                        <div className='d-flex align-items-center gap-2'>
                            <div style={{cursor: 'pointer'}}
                                 className={`currency-icon ${pricingListVisibility ? 'success' : 'warning'}`}>
                                <SvgIcon onClick={() => setPricingListVisibility(!pricingListVisibility)}
                                         iconId={'sale'}/>
                            </div>
                            <div>
                                <H6 attrH6={{className: 'f-14 mb-1'}}>{selectedParticipantWallet?.last_transaction?.description}</H6>
                                <div className='d-flex align-items-center gap-1'>
                                    <span className={`status bg-success`}/>
                                    <span className='f-light'>{'LKR'}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td className='text-end'>
                        <H6 attrH6={{className: 'f-14 f-w-400 mb-1'}}>
                            {(selectedParticipantWallet?.last_transaction ? selectedParticipantWallet?.last_transaction?.amount : 0).toLocaleString('en-LK', {
                                style: 'currency',
                                currency: 'LKR',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </H6>
                        <span
                            className={`font-success`}>{selectedParticipantWallet?.current_balance?.toLocaleString('en-LK', {
                            style: 'currency',
                            currency: 'LKR',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}</span>
                    </td>
                </tr>
                </tbody>
            </Table> : null
            }
            <div className='m-t-20 m-b-20 m-checkbox-inline custom-radio-ml'>
                {selectedParticipantID && selectedParticipantWallet ? bordBookingTypes.map((boardBookingType, key) =>
                    <div className='radio radio-primary' key={key}>
                        <Input id={`board_booking_type_id_${boardBookingType.id}`} type='radio'
                               name='board_booking_type_id'
                               disabled={selectedParticipantWallet?.current_balance < boardBookingType.amount}
                               value={boardBookingType.id} innerRef={ref} {...rest} />
                        <Label className='mb-0' for={`board_booking_type_id_${boardBookingType.id}`}>
                            {boardBookingType.booking_type}
                            <span className='digits'> {boardBookingType.amount.toLocaleString('en-LK', {
                                style: 'currency',
                                currency: 'LKR',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}</span>
                        </Label>
                    </div>) : null}
            </div>
            {pricingListVisibility && selectedParticipantID && selectedParticipantWallet ? <div style={{
                display: 'flex',
                flexWrap: 'nowrap',
                overflowX: 'scroll'
            }}>
                {pricingList.map((pricing, key) => <Col xl="4 xl-50" sm="6" className="box-col-6 " style={{padding: 10}}
                                                        key={key}>
                    <WalletFixAmountForm callBack={() => getWallet(selectedParticipantID)} price={pricing}
                                         impactorID={selectedParticipantID} actorID={selectedParticipantWallet?.id}  transactionType={'transaction-type-point-transfer-participant-board'}/>
                </Col>)}
            </div> : null}

            <FormGroup>
                <Btn attrBtn={{
                    className: 'd-block w-100 mt-4',
                    color: 'primary',
                    type: 'submit'
                }}>{'Add'}</Btn>
            </FormGroup>
        </Form>
    </Fragment>);
};

export default BoardNumberParticipantForm;